import { InjectionToken } from '@angular/core';
import type { Firestore } from '@firebase/firestore';

export const FIRESTORE_INSTANCE = new InjectionToken<Firestore>('FIRESTORE_INSTANCE');
